import LegalPage from "@/pages/LegalPage";

// A plain-English starter terms document. As above — this is a
// reasonable starting point for a beta service; run it past counsel
// before broad launch.
export default function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      lastUpdated="July 21, 2026"
      testId="terms-of-service-page"
    >
      <p>
        These Terms of Service ("Terms") govern your use of Your Monday Brief
        ("the Service"), operated by Bull Shark Builds. By creating an account
        or using the Service, you agree to these Terms.
      </p>

      <h2>1. What the Service does</h2>
      <p>
        Your Monday Brief composes and delivers a weekly business advisory
        email to local trade and service businesses. The Service is intended
        to be informational and advisory — it is not a substitute for
        professional advice from your accountant, lawyer, or other advisors.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old and legally authorized to represent
        the business you sign up for.
      </p>

      <h2>3. Your account</h2>
      <p>
        You are responsible for the accuracy of the information you provide
        during onboarding, and for keeping your account credentials secure.
        Notify us immediately if you suspect unauthorized use of your account.
      </p>

      <h2>4. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service to violate any law or infringe anyone's rights.</li>
        <li>Attempt to gain unauthorized access to the Service, other accounts, or our infrastructure.</li>
        <li>Send us content that is fraudulent, misleading, harmful, or that impersonates another business.</li>
        <li>Resell, redistribute, or repurpose Your Monday Brief content without our written permission.</li>
      </ul>

      <h2>5. Fees and free trial</h2>
      <p>
        The Service may be offered on a free trial or paid subscription basis.
        We'll tell you clearly what a plan costs before you enter payment
        details. You can cancel at any time from your settings page.
      </p>

      <h2>6. Cancellation and refunds</h2>
      <p>
        You can pause or cancel your Monday Brief at any time. Fees already
        charged for the current billing period are non-refundable except
        where required by law.
      </p>

      <h2>7. Content and intellectual property</h2>
      <p>
        The Service, including the brief format, the templates, the underlying
        engine, and all copy we write, is the intellectual property of Bull
        Shark Builds. You retain ownership of the business information you
        provide to us; you grant us a limited license to use it to operate
        and improve the Service.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        The Service is provided "as is". While we take care to compose
        recommendations that genuinely help, we do not guarantee any
        specific business outcome. Your Monday Brief is not a substitute
        for hands-on judgement about your business.
      </p>

      <h2>9. Limitation of liability</h2>
      <p>
        To the maximum extent allowed by law, Bull Shark Builds will not be
        liable for any indirect, incidental, or consequential damages arising
        from your use of the Service. Our total liability for any claim will
        not exceed the amount you paid us in the twelve months before the
        claim arose.
      </p>

      <h2>10. Changes to the Service or these Terms</h2>
      <p>
        We may change the Service or these Terms from time to time. If we
        make material changes, we'll tell you inside a Monday Brief or by
        email before the change takes effect.
      </p>

      <h2>11. Termination</h2>
      <p>
        We may suspend or end your account if you materially breach these
        Terms. You may end your account at any time by cancelling from your
        settings page.
      </p>

      <h2>12. Governing law</h2>
      <p>
        These Terms are governed by the laws of the state in which Bull Shark
        Builds is registered, without regard to conflict-of-laws principles.
      </p>

      <h2>13. Contact</h2>
      <p>
        Questions? Email <a href="mailto:briefs@bullsharkbuilds.com">briefs@bullsharkbuilds.com</a>.
      </p>
    </LegalPage>
  );
}
